<template>
  <div class="layout">
    <Row :gutter="8">
      <Col :xs="4" :sm="4" :md="4" :lg="4">
      <Card :padding="0">
        <Row>
          <Col :xs="9" :sm="9" :md="9" :lg="9" style="background: #2d8cf0" class="center_style_icon">
          <svg-icon :icon-class="'个数'" class="svg-icon_home_index" />
          </Col>
          <Col :xs="15" :sm="15" :md="15" :lg="15" class="center_style_around">
          <p class="count_style">{{countInfo.totalQuantity}}</p>
          <font class="count_title_style">全部电梯</font>
          </Col>
        </Row>
      </Card>
      </Col>
      <Col :xs="4" :sm="4" :md="4" :lg="4">
      <Card :padding="0">
        <Row>
          <Col :xs="9" :sm="9" :md="9" :lg="9" style="background: #19be6b" class="center_style_icon">
          <svg-icon :icon-class="'在线个数'" class="svg-icon_home_index" />
          </Col>
          <Col :xs="15" :sm="15" :md="15" :lg="15" class="center_style_around">
          <p class="count_style">{{countInfo.onlineQuantity}}</p>
          <font class="count_title_style">在线个数</font>
          </Col>
        </Row>
      </Card>
      </Col>
      <Col :xs="4" :sm="4" :md="4" :lg="4">
      <Card :padding="0">
        <Row>
          <Col :xs="9" :sm="9" :md="9" :lg="9" style="background: #808695" class="center_style_icon">
          <svg-icon :icon-class="'离线个数'" class="svg-icon_home_index" />
          </Col>
          <Col :xs="15" :sm="15" :md="15" :lg="15" class="center_style_around">
          <p class="count_style">{{countInfo.offlineQuantity}}</p>
          <font class="count_title_style">离线个数</font>
          </Col>
        </Row>
      </Card>
      </Col>
      <Col :xs="4" :sm="4" :md="4" :lg="4">
      <Card :padding="0">
        <Row>
          <Col :xs="9" :sm="9" :md="9" :lg="9" style="background: #ff9900" class="center_style_icon">
          <svg-icon :icon-class="'检修个数'" class="svg-icon_home_index" />
          </Col>
          <Col :xs="15" :sm="15" :md="15" :lg="15" class="center_style_around">
          <p class="count_style">{{countInfo.overhaulQuantity}}</p>
          <font class="count_title_style">检修个数</font>
          </Col>
        </Row>
      </Card>
      </Col>
      <Col :xs="4" :sm="4" :md="4" :lg="4">
      <Card :padding="0">
        <Row>
          <Col :xs="9" :sm="9" :md="9" :lg="9" style="background: #ed4014" class="center_style_icon">
          <svg-icon :icon-class="'故障个数'" class="svg-icon_home_index" />
          </Col>
          <Col :xs="15" :sm="15" :md="15" :lg="15" class="center_style_around">
          <p class="count_style">{{countInfo.faultQuantity}}</p>
          <font class="count_title_style">故障个数</font>
          </Col>
        </Row>
      </Card>
      </Col>
      <Col :xs="4" :sm="4" :md="4" :lg="4">
      <Card :padding="0">
        <Row>
          <Col :xs="9" :sm="9" :md="9" :lg="9" style="background: #5cadff" class="center_style_icon">
          <!-- <svg-icon :icon-class="'操作'" class="svg-icon_home_index" /> -->
          </Col>
          <Col :xs="15" :sm="15" :md="15" :lg="15" class="center_style_around">
          <p class="count_style">操作</p>
          <font class="count_title_style" @click="goToMap">查看分布地图</font>
          </Col>
        </Row>
      </Card>
      </Col>
    </Row>
    <div style="margin-top:8px" />
    <Row :gutter="8">
      <Col :xs="8" :sm="8" :md="8" :lg="8">
      <Card>
        <highcharts v-if="optionPie.series[0].data.length !== 0" :options="optionPie"></highcharts>
        <p class="nodata" v-if="optionPie.series[0].data.length === 0">
          <svg-icon :icon-class="'encourage'" class="svg-icon_home_no_data" /><br>
          昨日暂无故障，赞赞赞
        </p>
      </Card>
      </Col>
      <Col :xs="16" :sm="16" :md="16" :lg="16">
      <Card>
        <highcharts v-if="optionIncivilization.xAxis.categories.length !== 0" :options="optionIncivilization">
        </highcharts>
        <p class="nodata" v-if="optionIncivilization.xAxis.categories.length === 0">
          <svg-icon :icon-class="'encourage'" class="svg-icon_home_no_data" /><br>
          没有不文明行为哦！赞赞赞
        </p>
      </Card>
      </Col>
    </Row>
    <div style="margin-top:8px" />
    <Row :gutter="8">
      <Col :xs="6" :sm="6" :md="6" :lg="6">
      <Card style="height: 450px">
        <p slot="title" style="height: auto">
          <svg-icon :icon-class="'代办'" class="svg-icon_home_title" />
          待办工单
        </p>
        <p class="nodata" v-if="AgencyWorkOrderList.length === 0">
          <svg-icon :icon-class="'index_no_data'" class="svg-icon_home_no_data" /><br>
          暂无待办工单
        </p>
        <List v-if="AgencyWorkOrderList.length !== 0" class="footer_info">
          <Scroll height="360" class="scorllbar" :on-reach-bottom="handleReachBottomAgencyWorkOrderList">
            <ListItem v-for="(item,index) in AgencyWorkOrderList" :key="index">
              <!-- :avatar="item.imgLs[0]" -->
              <ListItemMeta :title="item.v_elevator_code" :description="item.v_system_remarks" />
              <template slot="action">
                <li>
                  <Button type="dashed" @click="actionWork(item.v_work_order_id)">前往处理</Button>
                </li>
              </template>
            </ListItem>
          </Scroll>
        </List>
        <Spin size="large" fix v-if="spinFlag1"></Spin>
      </Card>
      </Col>
      <Col :xs="6" :sm="6" :md="6" :lg="6">
      <Card style="height: 450px">
        <p slot="title" style="height: auto">
          <svg-icon :icon-class="'提醒事项'" class="svg-icon_home_title" />
          提醒事项
        </p>
        <p v-if="noticeList.length === 0" class="nodata">
          <svg-icon :icon-class="'index_no_data'" class="svg-icon_home_no_data" /><br>
          暂无提醒事项
        </p>
        <CellGroup v-if="noticeList.length !== 0" class="footer_info">
          <Scroll height="360" class="scorllbar" :on-reach-bottom="handleReachBottomNoticeList">
            <Cell v-for="(item,index) in noticeList" :key="index" :title="item.v_message">
              <Icon type="ios-clipboard-outline" slot="extra" />
            </Cell>
          </Scroll>
        </CellGroup>
        <Spin size="large" fix v-if="spinFlag2"></Spin>
      </Card>
      </Col>
      <Col :xs="6" :sm="6" :md="6" :lg="6">
      <Card style="height: 450px">
        <p slot="title" style="height: auto">
          <svg-icon :icon-class="'关注'" class="svg-icon_home_title" />
          需关注电梯
        </p>
        <p v-if="followList.length === 0" class="nodata">
          <svg-icon :icon-class="'index_no_data'" class="svg-icon_home_no_data" /><br>
          暂无需关注电梯
        </p>
        <CellGroup v-if="followList.length !== 0" class="footer_info">
          <Scroll height="360" class="scorllbar" :on-reach-bottom="handleReachBottomFollowList">
            <Cell v-for="(item,index) in followList" :key="index" :title="item.v_elevator_code" :label="item.v_message"
              @click.native="actionElevatorCollect(item.v_elevator_code)"></Cell>
          </Scroll>
        </CellGroup>
        <Spin size="large" fix v-if="spinFlag3"></Spin>
      </Card>
      </Col>
      <Col :xs="6" :sm="6" :md="6" :lg="6">
      <Card style="height: 450px">
        <p slot="title" style="height: auto">
          <svg-icon :icon-class="'收藏'" class="svg-icon_home_title" />
          收藏的电梯
        </p>
        <p class="nodata" v-if="ElevatorCollectList.length === 0">
          <svg-icon :icon-class="'index_no_data'" class="svg-icon_home_no_data" /><br>
          暂无收藏电梯
        </p>
        <List v-if="ElevatorCollectList.length !== 0" class="footer_info">
          <Scroll height="360" class="scorllbar" :on-reach-bottom="handleReachBottomElevatorCollectList">
            <ListItem v-for="(item,index) in ElevatorCollectList" :key="index">
              <!-- :avatar="item.imgLs[0]" -->
              <ListItemMeta :title="item.v_elevator_code" :description="item.v_addess" />
              <template slot="action">
                <li>
                  <Button type="dashed" @click="actionElevatorCollect(item.v_elevator_code)">查看</Button>
                </li>
              </template>
            </ListItem>
          </Scroll>
        </List>
        <Spin size="large" fix v-if="spinFlag4"></Spin>
      </Card>
      </Col>
    </Row>
    <div style="margin-top:10px" />
  </div>
</template>
<script>
import index from './js/index.js'
export default {
  data() {
    return {
      map: {
        center: { lng: 121.447254, lat: 31.32362 },
        zoom: 15,
        show: true,
        dragging: true
      }
    }
  },
  methods: {
    handler({ BMap, map }) {
      // 鼠标缩放
      map.enableScrollWheelZoom(false)
      // 点击事件获取经纬度
      map.addEventListener('click', function(e) {
        console.log(e.point.lng, e.point.lat)
      })
    }
  },
  mixins: [index]
}
</script>
<style scoped lang="scss">
@import "./css/index.scss";
.demo-badge {
  width: 50px;
  height: 50px;
  background: #eee;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 13px;
}
.demo-badge2 {
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-radius: 6px;
  align-items: center;
  font-size: 13px;
}

.map {
  width: 100%;
  height: 400px;
}

.center_style {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.center_style_icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 88px;
}

.center_style_around {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.count_style {
  font-weight: 600;
  font-size: 30px;
  height: 54px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.count_title_style {
  font-size: 14px;
  height: 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.elevatorMap {
  position: relative;
}

.elevatorList {
  position: absolute;
  right: 10px;
  top: 0;
  width: 400px;
  height: 100%;
}
.footer_info {
  height: 360px;
  overflow: auto;
}
.footer_info::-webkit-scrollbar {
  display: none;
}

.scorllbar {
  overflow-y: hidden;
}

.scorllbar::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}
</style>
